import { Pagination, Select, Table, Tag, Typography } from "antd";
import ChangeDealerCode from "../../components/common/changeDealerCode";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { GetDealerOrdersList } from "../../../redux/actions/userActions/ordersActions";
import { Link, useLocation } from "wouter";
import { getQueryParams } from "../../../utilities/getQueryParams";
import { useLoader } from "../../../utilities/useLoader";

const { Title } = Typography;
const OrderList = () => {
  const authData = useSelector((state) => state.auth_store);
  const dealer_code = authData?.defaultDealerCode;
  const [ordersList, setOrdersList] = useState([]);
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const initialPage = params.page || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalOrders, setTotalOrders] = useState(0);
  const [orderType, setOrderType] = useState();
  const [loader, startLoader, endLoader] = useLoader();
  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/orders?page=${page}`);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    startLoader();
    dispatch(
      GetDealerOrdersList({
        dealerCode: dealer_code,
        page: currentPage,
        perPage: 10,
      })
    )
      .then((res) => {
        setOrdersList(res?.payload?.data?.data);
        setTotalOrders(res?.payload?.data?.pagination?.total);
        endLoader();
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });
  }, [dispatch, setOrdersList, dealer_code, currentPage]);
  const columns = [
    {
      title: "Order Id",
      dataIndex: "orderId",
      key: "orderId",
      // fixed: "left",
      render: (text) => <Link to="#">{text}</Link>,
    },
    {
      title: "Order Total",
      dataIndex: "orderTotal",
      key: "orderTotal",
    },
    {
      title: "Order Type",
      dataIndex: "orderType",
      key: "orderType",
    },
    {
      title: "Requested Date",
      dataIndex: "requestedDate",
      key: "requestedDate",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (status, record) => {
        let color =
          status === "approved" || status === "Approved"
            ? "green"
            : status === "error" || status === "Error"
            ? "red"
            : "geekblue";
        return (
          <Tag
            color={color}
            key={status}
            className="font-bold"
            style={{ cursor: status === "Error" ? "pointer" : "default" }}
          >
            {status.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (record) => (
        <Link
          to={`/order-details?orderId=${record.orderId}`}
          className="text-red-600"
        >
          View
        </Link>
      ),
    },
  ];
  console.log("Order type is:", orderType);
  return (
    <div className="bg-gray-50 rounded-lg m-4 p-4 shadow-lg">
      <div className="sm:flex justify-between items-center">
        <Title level={2}>Confirmed Orders</Title>
        <div className="flex gap-7">
          {/* <div className="flex justify-between items-center">
            <div className="font-semibold mr-2 max-sm:text-lg">Order Type:</div>
            <Select
              className="w-[150px]"
              value={orderType}
              placeholder="Select Order Type"
              onChange={(value) => {
                setOrderType(value);
              }}
              allowClear={true}
              options={[
                {
                  key: "Normal",
                  value: "Normal Order",
                  label: "Normal Order",
                },
                {
                  key: "Blanket Order",
                  value: "Blanket Order",
                  label: "Blanket Order",
                },
              ]}
            />
          </div> */}
          <ChangeDealerCode />
        </div>
      </div>
      <Table
        className="max-sm:overflow-x-scroll max-w-full"
        columns={columns}
        dataSource={ordersList}
        pagination={false}
        loading={loader}
      />
      <div className="flex justify-between items-center mt-4">
        <Pagination
          current={currentPage}
          total={totalOrders}
          pageSize={10}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};
export default OrderList;
